import { graphqlClient } from '@/modules/graphql'

class GraphqlBase {
  constructor () {
    this.graphqlClient = graphqlClient
  }
}

export default GraphqlBase
